import { Button, Grid, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import { getOtherTextFieldSx, optionControlStyle } from '../../contractStyles';

FormButtonOptions.propTypes = {
    fieldName: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    otherOption: PropTypes.bool,
};

export default function FormButtonOptions({ fieldName, options = [], disabled = false, otherOption = true }) {
    const { control } = useFormContext();
    const { field } = useController({ name: fieldName, control });

    const isMatchingButtonOption = options.find((option) => String(option ?? '').trim().toLowerCase() === (field.value ?? '').trim().toLowerCase());

    const isButtonSelected = (option) => isMatchingButtonOption && isMatchingButtonOption === option;

    const otherValueDisplay = !field.value || isMatchingButtonOption ? '' : field.value;

    return (
        <Grid container spacing={1}>
            {options.map((option) => (
                <Grid item key={option} sx={{ display: 'flex', alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'flex-start' }}>
                    <Button
                        disabled={disabled}
                        variant={isButtonSelected(option) ? 'contained' : 'outlined'}
                        onClick={() => field.onChange(option)}
                        sx={{ ...optionControlStyle, justifyContent: 'flex-start', alignContent: 'flex-start', mt: 1 }}
                    >
                        {option}
                    </Button>
                </Grid>
            ))}

            {otherOption && (
                <Grid item sx={{ display: 'flex', alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'flex-start' }}>
                    <TextField
                        size="small"
                        InputProps={{ disableUnderline: true }}
                        inputProps={{ size: Math.max(5, (otherValueDisplay?.length)) }}
                        variant={"outlined"}
                        placeholder="Other"
                        disabled={disabled}
                        value={otherValueDisplay}
                        onChange={(event) => field.onChange(event.target.value)}
                        sx={getOtherTextFieldSx(!!otherValueDisplay)}
                    />
                </Grid>
            )}
        </Grid>
    );
}



